import Vue from 'vue';
import VueHeadful from 'vue-headful';
import Vuelidate from 'vuelidate';
import '@icabbi/vue-components';
import VuelidateErrorExtractor from 'vuelidate-error-extractor';

import makeMockServer from './mock/mockServer';
import environment from './environment';

import i18n from './i18n';
import vuetify from './plugins/vuetify';

import '@icabbi/vue-components/dist/vue-components.css';
import App from './App.vue';
import router from './router';
import store from './store';
import i18nAttributes from './i18nAttributes';

import LargeButton from './components/elements/LargeButton.vue';
import ErrorPage from './components/elements/ErrorPage.vue';
import AlertSnackbar from './components/elements/AlertSnackbar.vue';

if (environment.isDevelopment() && environment.isUsingMockApi()) {
  makeMockServer({ environment: 'development' });
}

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(VuelidateErrorExtractor, {
  i18n: 'validations',
  i18nAttributes,
});

Vue.component('vue-headful', VueHeadful);
Vue.component('large-button', LargeButton);
Vue.component('error-page', ErrorPage);
Vue.component('alert-snackbar', AlertSnackbar);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');
